import React, { useState } from 'react'
import '../todo list Components/Maintodo.css'

function Maintodo() {

    let [userInput, setUserInput] = useState()

    let inputEvent = (event) => {
        setUserInput(event.target.value)
    }


    let [text, setText] = useState([])

    // let [visible, setVisible] = useState('none')


    let HandleSubmit = (event) => {
        event.preventDefault()
        setText((oldItem) => {
            setUserInput("")
            return [...oldItem, userInput]

        })

    }


    let deleteData = (index) => {
        setText((oldItems) => {
            return oldItems.filter((_, itemIndex) => itemIndex !== index);
        })
    }


    return (
        <>
            <div className="container-fluid ">

                <div className="container">
                    <div className="mainContainer border cards">

                        <div className="setup-heading">
                            <h1 className='heading'>To-Do Application</h1>
                        </div>

                        <form onSubmit={HandleSubmit}>
                            <div className="setup-input">
                                <div className="input">
                                    <input type="text" placeholder='Add Your New To-Do' className='userInput border'  onChange={inputEvent} value={userInput} />
                                </div>
                                <button type="submit" className="btn btn-primary btn1" >+</button>
                            </div>
                        </form>

                        <div className="setup-field" >

                            {/* <p className='p1 '>{text}<button type="button" class="btn btn-primary btn2" >x</button></p> */}

                            {text.map((item, index) => {
                                return <p className='p1 ' key={index}>
                                    {item}

                                    <button type="button" className="btn btn-primary btn2" onClick={() => deleteData(index)} >
                                        x
                                    </button></p>
                            })}

                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default Maintodo
